import { render, staticRenderFns } from "./UserListAvatar.vue?vue&type=template&id=4c08763d&"
import script from "./UserListAvatar.vue?vue&type=script&lang=ts&"
export * from "./UserListAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports